module.exports = __webpack_public_path__ + "60fdb687cd234f26ea8ee595272aa395.svg";